import { fetchUtils } from "react-admin";

// local
// export const baseURL = 'http://localhost:5002';

// Production
export const baseURL = 'https://billing-c02a0.el.r.appspot.com';


export const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const accessToken = localStorage.getItem('access_token');
    options.headers.set('Authorization',accessToken );
    return fetchUtils.fetchJson(url, options);
};